(function () {

  var checkExist = setInterval(function () {
    var host = document.querySelector('#upCart');
    var root = host && host.shadowRoot ? host.shadowRoot : null;
    if (!root) {
      return;
    }
    var links = root.querySelectorAll(
      '#CartPopup .upcart-cart-body .upcart-internal-cart-items .upcart-internal-cart-item a[href^="/products/get-3-x-2ml-samples-for-only-5"]'
    );
    if (links.length > 0) {
      links.forEach(function (link) {
        link.style.pointerEvents = 'none';
        link.setAttribute('tabindex', '-1');
        link.style.cursor = 'default';
      });
    }
  });

  // const UPCART_HOST_ID     = 'upCart';
  // const REWARDS_SELECTOR   = '.upcart-internal-rewards.upcart-public-rewards';
  // const HIDE_CLASS         = 'upcart-rewards--hidden';
  // const STYLE_ID           = 'upcart-rewards-hide-style';

  // const HIDDEN_VARIANT_IDS = [
  //   47906937241765,
  //   44476231450789
  // ];

  // const FREE_SHIPPING_UNLOCKED_VARIANT_ID = 47944158707877;
  // const PROGRESS_FILL_SELECTOR = '.upcart-internal-component-segmented-progress-bar__segment-fill';
  // const MESSAGE_SELECTOR       = '.upcart-internal-rewards__message';
  // const FREE_SHIPPING_TEXT     = 'Free shipping unlocked!';


  // /*
  //  * NEW:
  //  * Control Shipping Protection toggle
  //  */
  // function controlShippingProtection(shadowRoot, classification) {
  //   const addonEls = shadowRoot.querySelectorAll(
  //     '.upcart-internal-addons.upcart-public-addons'
  //   );

  //   addonEls.forEach(function (addonEl) {
  //     const titleEl = addonEl.querySelector(
  //       '.upcart-internal-addons__content-title'
  //     );

  //     /*
  //      * Only target Shipping Protection addon
  //      */
  //     if (
  //       !titleEl ||
  //       titleEl.textContent.trim().toLowerCase() !== 'shipping protection'
  //     ) {
  //       return;
  //     }

  //     /*
  //      * Find the toggle wrapper
  //      */
  //     const toggleWrapper = addonEl.querySelector(
  //       '.upcart-internal-addons__toggle-wrapper'
  //     );

  //     if (!toggleWrapper) return;

  //     /*
  //      * Find possible toggle element
  //      */
  //     const toggleEl = toggleWrapper.querySelector(
  //       'input[type="checkbox"], button, [role="switch"]'
  //     );

  //     /*
  //      * FIXED (bug):
  //      * When the user turns the toggle ON, UpCart fires a /cart/add.js
  //      * request to actually add the Shipping Protection line item to
  //      * "upcart-internal-cart-items". That request is async.
  //      *
  //      * Our update() cycle can run (via the mutation observer / debounced
  //      * cart-endpoint patch) BEFORE that add request finishes, so the
  //      * cart.js snapshot we just fetched is still the OLD cart - which can
  //      * still classify as "force-complete". We were then immediately
  //      * calling toggleEl.click() to force it back OFF, undoing the user's
  //      * own action before the add-to-cart call even completed. That's why
  //      * toggling ON stopped actually adding the product to the cart.
  //      *
  //      * Fix: remember when the user themselves interacted with the toggle
  //      * and give it a short grace period before this function is allowed
  //      * to auto-turn it off again. This lets the real /cart/add.js call
  //      * finish and the NEXT update() cycle see the true, up-to-date cart.
  //      */
  //     const GRACE_MS = 1500;

  //     if (toggleEl && !toggleWrapper.dataset.upcartInteractionListenerAttached) {
  //       toggleWrapper.dataset.upcartInteractionListenerAttached = 'true';

  //       ['click', 'change'].forEach(function (evt) {
  //         toggleEl.addEventListener(evt, function () {
  //           // Ignore clicks we triggered ourselves below
  //           if (toggleWrapper.dataset.upcartProgrammaticClick === 'true') return;
  //           toggleWrapper.dataset.upcartUserInteractedAt = String(Date.now());
  //         });
  //       });
  //     }

  //     const shouldDisable = classification === 'force-complete';

  //     if (shouldDisable) {

  //       const recentUserInteraction =
  //         toggleWrapper.dataset.upcartUserInteractedAt &&
  //         Date.now() - Number(toggleWrapper.dataset.upcartUserInteractedAt) < GRACE_MS;

  //       if (recentUserInteraction) {
  //         // User just touched it - let the add/remove request settle
  //         // before we decide anything. Re-checked on the next cycle.
  //         return;
  //       }

  //       /*
  //        * If Shipping Protection is currently ON,
  //        * click it once to turn it OFF
  //        */
  //       if (toggleEl) {
  //         const isChecked =
  //           toggleEl.checked === true ||
  //           toggleEl.getAttribute('aria-checked') === 'true';

  //         if (
  //           isChecked &&
  //           !toggleWrapper.dataset.upcartShippingProtectionTurnedOff
  //         ) {
  //           toggleWrapper.dataset.upcartShippingProtectionTurnedOff = 'true';

  //           toggleWrapper.dataset.upcartProgrammaticClick = 'true';
  //           toggleEl.click();
  //           delete toggleWrapper.dataset.upcartProgrammaticClick;
  //         }
  //       }

  //       /*
  //        * Disable future clicks
  //        */
  //       toggleWrapper.style.setProperty(
  //         'pointer-events',
  //         'none',
  //         'important'
  //       );

  //       toggleWrapper.style.setProperty(
  //         'cursor',
  //         'not-allowed',
  //         'important'
  //       );

  //     } else {

  //       /*
  //        * Restore normal toggle functionality
  //        */
  //       toggleWrapper.style.removeProperty('pointer-events');
  //       toggleWrapper.style.removeProperty('cursor');

  //       delete toggleWrapper.dataset.upcartShippingProtectionTurnedOff;
  //     }
  //   });
  // }

  // const SHIPPING_PROTECTION_VARIANT_ID = '44476231450789';

  // function findShippingProtectionElements(shadowRoot) {
  //   const found = new Set();

  //   // 1) Carousel upsell tile
  //   shadowRoot
  //     .querySelectorAll('[data-upcart-upsell*="shipping-protection" i]')
  //     .forEach(function (upsellEl) {
  //       const carouselSlide = upsellEl.closest(
  //         '[class*="carousel__slide"], [class*="carousel-slide"], [role="group"][aria-roledescription="slide"]'
  //       );
  //       found.add(carouselSlide || upsellEl);
  //     });

  //   // 2) Cart line-items (in case Shipping Protection ends up as a cart item)
  //   shadowRoot
  //     .querySelectorAll(
  //       [
  //         `[data-variant-id="${SHIPPING_PROTECTION_VARIANT_ID}"]`,
  //         `[data-variant_id="${SHIPPING_PROTECTION_VARIANT_ID}"]`,
  //         `[data-line-item-variant-id="${SHIPPING_PROTECTION_VARIANT_ID}"]`,
  //         `[data-id="${SHIPPING_PROTECTION_VARIANT_ID}"]`,
  //         `a[href*="variant=${SHIPPING_PROTECTION_VARIANT_ID}"]`,
  //         `a[href*="/${SHIPPING_PROTECTION_VARIANT_ID}"]`
  //       ].join(',')
  //     )
  //     .forEach(function (el) {
  //       const lineItem = el.closest(
  //         '[class*="cart-item"], [class*="cart_item"], [class*="line-item"], [class*="line_item"]'
  //       );
  //       found.add(lineItem || el);
  //     });

  //   return Array.from(found).filter(Boolean);
  // }

  // function toggleShippingProtectionVisibility(shadowRoot, classification) {
  //   const shouldHide = classification === 'force-complete';

  //   findShippingProtectionElements(shadowRoot).forEach(function (el) {
  //     el.classList.toggle(HIDE_CLASS, shouldHide);
  //   });
  // }


  // function getShadowRoot() {
  //   const host = document.getElementById(UPCART_HOST_ID);
  //   return host && host.shadowRoot ? host.shadowRoot : null;
  // }

  // function injectStyle(shadowRoot) {
  //   if (shadowRoot.querySelector('#' + STYLE_ID)) return;
  //   const style = document.createElement('style');
  //   style.id    = STYLE_ID;
  //   style.textContent = `.${HIDE_CLASS}{display:none!important}`;
  //   shadowRoot.appendChild(style);
  // }

  // async function fetchCart() {
  //   try {
  //     const resp = await fetch('/cart.js', { cache: 'no-store' });
  //     return resp.ok ? await resp.json() : null;
  //   } catch (_) {
  //     return null;
  //   }
  // }

  // function classifyCart(items) {
  //   if (!items || items.length === 0) return 'normal';

  //   const realProducts = items.filter(function (item) {
  //     return (
  //       !HIDDEN_VARIANT_IDS.includes(item.variant_id) &&
  //       !HIDDEN_VARIANT_IDS.includes(item.id)
  //     );
  //   });

  //   if (realProducts.length === 0) return 'hide';

  //   const nonSpecial = realProducts.filter(function (item) {
  //     return (
  //       item.variant_id !== FREE_SHIPPING_UNLOCKED_VARIANT_ID &&
  //       item.id !== FREE_SHIPPING_UNLOCKED_VARIANT_ID
  //     );
  //   });

  //   if (nonSpecial.length === 0) return 'force-complete';

  //   return 'normal';
  // }

  // function applyRewardsState(shadowRoot, rewardsEl, classification) {
  //   rewardsEl.classList.toggle(HIDE_CLASS, classification === 'hide');

  //   const fillEls    = shadowRoot.querySelectorAll(PROGRESS_FILL_SELECTOR);
  //   const messageEl  = shadowRoot.querySelector(MESSAGE_SELECTOR);
  //   const messageP   = messageEl ? (messageEl.querySelector('p') || messageEl) : null;

  //   if (classification === 'force-complete') {
  //     // fillEls.forEach(function (el) {
  //     //   el.style.setProperty('width', '100%', 'important');
  //     // });

  //     // if (messageP) {
  //     //   if (messageP.dataset.upcartOriginalText === undefined) {
  //     //     messageP.dataset.upcartOriginalText = messageP.textContent;
  //     //   }

  //     //   messageP.textContent = FREE_SHIPPING_TEXT;
  //     // }
  //   } else {
  //     if (
  //       messageP &&
  //       messageP.dataset.upcartOriginalText !== undefined
  //     ) {
  //       messageP.textContent = messageP.dataset.upcartOriginalText;
  //     }
  //   }


  //   /*
  //    * NEW:
  //    * Disable Shipping Protection when
  //    * only variant 47944158707877 is in cart
  //    */
  //   controlShippingProtection(shadowRoot, classification);
  //   toggleShippingProtectionVisibility(shadowRoot, classification);
  // }

  // let isUpdating = false;

  // async function update() {
  //   if (isUpdating) return false;
  //   isUpdating = true;

  //   try {
  //     const shadowRoot = getShadowRoot();
  //     if (!shadowRoot) return false;

  //     const rewardsEl = shadowRoot.querySelector(REWARDS_SELECTOR);
  //     if (!rewardsEl) return false;

  //     injectStyle(shadowRoot);

  //     const cart = await fetchCart();
  //     if (!cart) return false;

  //     const classification = classifyCart(cart.items || []);

  //     applyRewardsState(
  //       shadowRoot,
  //       rewardsEl,
  //       classification
  //     );

  //     return true;
  //   } finally {
  //     isUpdating = false;
  //   }
  // }

  // const FAST_POLL_MS = 200;
  // const TIMEOUT_MS   = 10000;

  // let fastIntervalId  = null;
  // let elapsed         = 0;
  // let initialized     = false;

  // let activeShadowObserver = null;

  // function stopFastPoll() {
  //   if (fastIntervalId !== null) {
  //     clearInterval(fastIntervalId);
  //     fastIntervalId = null;
  //   }
  // }

  // function markInitialized() {
  //   if (initialized) return;

  //   initialized = true;
  //   stopFastPoll();

  //   if (activeShadowObserver !== null) {
  //     activeShadowObserver.disconnect();
  //     activeShadowObserver = null;
  //   }
  // }

  // async function fastTick() {
  //   elapsed += FAST_POLL_MS;

  //   const done = await update();

  //   if (done) {
  //     markInitialized();
  //     return;
  //   }

  //   if (elapsed >= TIMEOUT_MS) {
  //     stopFastPoll();
  //   }
  // }

  // const MUTATION_DEBOUNCE_MS = 150;
  // let mutationDebounceTimer = null;

  // function watchShadowRoot(shadowRoot) {
  //   const observer = new MutationObserver(function () {
  //     if (mutationDebounceTimer !== null) {
  //       clearTimeout(mutationDebounceTimer);
  //     }

  //     mutationDebounceTimer = setTimeout(async function () {
  //       mutationDebounceTimer = null;

  //       const done = await update();

  //       if (done && !initialized) {
  //         markInitialized();
  //       }
  //     }, MUTATION_DEBOUNCE_MS);
  //   });

  //   observer.observe(shadowRoot, {
  //     childList: true,
  //     subtree: true
  //   });

  //   activeShadowObserver = observer;
  // }

  // function watchForHost() {
  //   const existingHost = document.getElementById(UPCART_HOST_ID);

  //   if (existingHost && existingHost.shadowRoot) {
  //     watchShadowRoot(existingHost.shadowRoot);
  //     return;
  //   }

  //   const bodyObserver = new MutationObserver(function (_, obs) {
  //     const host = document.getElementById(UPCART_HOST_ID);

  //     if (host && host.shadowRoot) {
  //       obs.disconnect();
  //       watchShadowRoot(host.shadowRoot);
  //     }
  //   });

  //   bodyObserver.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });
  // }

  // const EVENT_DEBOUNCE_MS = 200;
  // let eventDebounceTimer = null;

  // function scheduleUpdate() {
  //   if (eventDebounceTimer !== null) {
  //     clearTimeout(eventDebounceTimer);
  //   }

  //   eventDebounceTimer = setTimeout(function () {
  //     eventDebounceTimer = null;
  //     update();
  //   }, EVENT_DEBOUNCE_MS);
  // }

  // const CART_ENDPOINT_RE =
  //   /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // function patchFetchForCartEvents() {
  //   if (typeof window.fetch !== 'function') return;

  //   const originalFetch = window.fetch;

  //   window.fetch = function (input, init) {
  //     const url =
  //       typeof input === 'string'
  //         ? input
  //         : (input && input.url) || '';

  //     const result = originalFetch.apply(this, arguments);

  //     if (CART_ENDPOINT_RE.test(url)) {
  //       result
  //         .then(function () {
  //           scheduleUpdate();
  //         })
  //         .catch(function () {});
  //     }

  //     return result;
  //   };
  // }

  // function patchXHRForCartEvents() {
  //   if (typeof XMLHttpRequest === 'undefined') return;

  //   const originalOpen = XMLHttpRequest.prototype.open;
  //   const originalSend = XMLHttpRequest.prototype.send;

  //   XMLHttpRequest.prototype.open = function (method, url) {
  //     this._upcartRewardsIsCartCall =
  //       typeof url === 'string' &&
  //       CART_ENDPOINT_RE.test(url);

  //     return originalOpen.apply(this, arguments);
  //   };

  //   XMLHttpRequest.prototype.send = function () {
  //     if (this._upcartRewardsIsCartCall) {
  //       this.addEventListener('loadend', function () {
  //         scheduleUpdate();
  //       });
  //     }

  //     return originalSend.apply(this, arguments);
  //   };
  // }

  // const CART_EVENT_NAMES = [
  //   'cart:updated',
  //   'cart:refresh',
  //   'cart:build',
  //   'cart:change',
  //   'cart:add'
  // ];

  // function listenForCartEvents() {
  //   CART_EVENT_NAMES.forEach(function (name) {
  //     document.addEventListener(name, scheduleUpdate);
  //   });
  // }

  // patchFetchForCartEvents();
  // patchXHRForCartEvents();
  // listenForCartEvents();

  // update().then(function (done) {
  //   if (done) {
  //     markInitialized();
  //     return;
  //   }

  //   fastIntervalId = setInterval(
  //     fastTick,
  //     FAST_POLL_MS
  //   );

  //   watchForHost();
  // });
})();